/**
 * Created by r4zi4l on 05.04.2024
 */

Reward.register("oldPiggyBank", {
    flyingAnimation: Reward.CUSTOM_COLLECT,

    getCustomRewardAnimation: function () {
        return bundles.custom_reward.jsons.coins_animation_json;
    },

    getCustomRewardIcon: function () {
        return bundles.custom_reward.jsons.piggybank_icon_json;
    },

    getCustomRewardText: function (value, prev) {
        const mission = cleverapps.missionManager.findByType(Mission.TYPE_OLD_PIGGY_BANK);
        if (!mission || !mission.isRunning()) {
            return;
        }

        if (mission.logic.isFull()) {
            return prev ? mission.result - value : Messages.get("PiggyBank.Full");
        }

        return prev ? mission.result - value : mission.result;
    },

    getCustomRewardEffect: function () {
        return "piggybank.custom_reward.coins";
    },

    getCustomRewardOpenEffect: function () {
        return "piggybank.custom_reward.open";
    },

    getCustomRewardCloseEffect: function () {
        return "piggybank.custom_reward.close";
    },

    getCustomRewardAfterUpdateEffect: function () {
        const mission = cleverapps.missionManager.findByType(Mission.TYPE_OLD_PIGGY_BANK);
        if (!mission || !mission.isRunning() || !mission.logic.isFull()) {
            return;
        }

        return "piggybank.custom_reward.coins.full";
    },

    parse: function (value, options) {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_OLD_PIGGY_BANK);
        if (mission && !mission.logic.isFull()) {
            return [new Reward("oldPiggyBank", Math.min(value, mission.logic.getMaxAmount() - mission.result), options)];
        }
        return [];
    },

    receive: function (value) {
        const mission = cleverapps.missionManager.findByType(Mission.TYPE_OLD_PIGGY_BANK);
        if (mission && mission.isRunning()) {
            mission.logic.add(value);
        }

        return function () {};
    }
});
